import AdminLoginApi from 'client/api/AdminLoginApi';
import Vue from 'vue';

export const MODIFY_PROPERTY = 'MODIFY_PROPERTY';
export const SWAP_STATE = 'SWAP_STATE';

export default {
  namespaced: true,
  state: {
    password: '',
    confirm: '',
    license: false,
    email: '',
    confirmationCode: '',
    otp: '',
  },
  mutations: {
    [MODIFY_PROPERTY](state, payload = { key: '', value: '' }) {
      if (state[payload.key] === undefined) return Error('Key does not exist on Reset Password payload');

      Vue.set(state, payload.key, payload.value);
      return state;
    },

    [SWAP_STATE](state, payload = {}) {
      Object.keys(payload).forEach(key => Vue.set(state, key, payload[key]));
      return state;
    },
  },
  actions: {
    commitPropertyChange({ commit }, payload = {}) {
      commit(MODIFY_PROPERTY, payload);
    },

    commitEntireStateChange({ commit }, payload = {}) {
      commit(SWAP_STATE, payload);
    },

    /**
     * Attempt to verify user-provided data to reset user's password
     *
     * @param {context.state} ResetPassword
     * @returns {Promise.resolve} The user has changed their password
     * {Promise.reject} General network Error
     * {Promise.reject} Status Code 401 and data: totpKey means TOTP verification required
     * before password and TOTP is reset
     */
    verifyResetPassword({ state }) {
      return AdminLoginApi.resetPassword(state);
    },

    /**
     * Attempt to verify user-provided data to reset user's password
     *
     * @param {context.state} ResetPassword
     * @returns {Promise.resolve} The user has changed their password
     * {Promise.reject} General network Error
     * {Promise.reject} Status Code 401 and data: totpKey means TOTP verification required
     * before password and TOTP is reset
     */
    verifyResetTOTP({ state }) {
      return AdminLoginApi.verifyMfaResetTOTP(state);
    },
  },
};
